import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { TimePickerComponent } from '@syncfusion/ej2-react-calendars'
import axios from 'axios';
import Select from 'react-select';
import $ from 'jquery';
const View = (props) => {

    const [items, setitems] = useState([]);
    const [addunit, setunit] = useState([])
    const [unitvalue, setunitvalue] = useState()
    const url = process.env.REACT_APP_APIURL + "Booking/GetMethod?companyid=" + props.companyid;
    useEffect(() => {
        setTimeout(() => {
            $('#example3').DataTable().destroy()
            populatedata()
        }, 100)

    }, []);
    useEffect(() => {

        $('#example3').DataTable();
    }, [items]);

    useEffect(() => {
      
    }, []);

    
    async function populatedata() {
        await fetch(url).then(res => res.json()).then(result =>

            setitems(result)
        );
    }
    async function deletedata(id) {
        const urldelete = process.env.REACT_APP_APIURL + 'Booking/DeleteMethod?id=' + id
        let res = await axios.post(urldelete)
        if (res.status == 200) {
            swal({
                title: "Deleted Successfully",
                icon: "success"
            })
            populatedata();

        }
    }

    async function handleEdit(id) {
        const newurl = process.env.REACT_APP_APIURL + "Booking/GetMethods?id=" + id + "&companyid=" + props.companyid;
        await fetch(newurl).then(res => res.json()).then(result => {
            
            setupdateitems({ ...updateitems, id: result.id, title: result.title, Mtype: result.mtype, company_id: props.companyid, Name: result.name })
            debugger;
           
            if (result.mtype == "1") {
                settypevalue({ ...typevalue, value: result.mtype, label: "Cash" })
            }
            if (result.mtype == "2") {
                settypevalue({ ...typevalue, value: result.mtype, label: "Bank" })
            }
          
        });
        $("#myModal").modal("show")
    }
    function handleDelete(id) {
        swal({
            title: "Are you sure?",
            //  text: "Once deleted, you will not be able to recover this imaginary file!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                deletedata(id);

            } else {
                swal("0 Rows deleted");
            }
        });
    }
    /////////////////////////////////////////////////////
    ////////////////UPDATE SHIFT/////////////////////////
    /////////////////////////////////////////////////////
    //const [updateitems, setupdateitems] = useState({ ShiftId: "", ShiftName: "", Slot: "", CheckInTime: "", CheckOutTime: "", type: "", UnitId: "", Amount: "", company_id: props.companyid })
    const [updateitems, setupdateitems] = useState({ id: "", typenew: "", title: "", company_id: props.companyid, Name: "" })
    const [typevalue, settypevalue] = useState()
    const [Mtype, setMtype] = useState([
        { label: "Cash", value: "1" },
        { label: "Bank", value: "2" },


    ])
    useEffect(() => {

    }, []);
    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setupdateitems({ ...updateitems, [name]: value })
    }
   
    const refresh = () => {
       
        setupdateitems({ ...updateitems, typenew: "", title: "", company_id: props.companyid, Name: ""  });
        settypevalue(null)
       
    }
    const savemethod = async (data) => {
        const url = process.env.REACT_APP_APIURL + "Booking/UpdateMethod";
        await fetch(url, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status == 200) {
                swal({
                    title: "Saved Successfully",
                    icon: "success"
                })
                refresh();
                populatedata();
                $("#myModal").modal("hide");
            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (items.Mtype === "") {
            swal({
                title: "Type Required!",
                icon: "error"
            })
            return;
        }
        if (items.title === "") {
            swal({
                title: "Title Required!",
                icon: "error"
            })
            return;
        }
        savemethod(updateitems);
        // console.log(items);
    }
    return (
        <div className="row">
            <div className="col-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-0">View List</h3>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table id="example3" className="display" data-page-length='50'>
                                <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th>Bank Title</th>
                                        <th>Person Name</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map(item =>
                                        <tr key={item.id}>
                                            <td>{item.type}</td>
                                            <td>{item.title}</td>
                                            <td>{item.name}</td>
                                            <td>
                                                <span className="d-flex">
                                                    <button href="#" className="btn btn-primary shadow btn-xs sharp me-2"
                                                        onClick={(id) => handleEdit(item.id)}>
                                                        <i className="fas fa-pencil-alt"></i>
                                                    </button>
                                                    <button href="#" className="btn btn-danger shadow btn-xs sharp"
                                                        onClick={(id) => handleDelete(item.id)}>
                                                        <i className="fa fa-trash"></i>
                                                    </button>
                                                </span>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div id="myModal" className="modal fade " tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="me-auto mb-5 mt-5 text-center mx-auto">Update Method</h3>
                            </div>
                            <div className="card-body">
                                <div className="basic-form">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row flex-column align-items-center">
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Type *</label>
                                                <Select value={typevalue} options={Mtype} onChange={(e) => { settypevalue(e); setitems({ ...items, Mtype: e.value }) }} />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Bank Title *</label>
                                                <input type="text" className="form-control" name="title" autoComplete="off" value={updateitems.title} onChange={handleInput} required />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Person Name</label>
                                                <input type="text" className="form-control" name="Name" autoComplete="off" value={updateitems.Name} onChange={handleInput} />
                                            </div>
                                           
                                            <br />
                                            <input type="submit" className="btn btn-primary" value="Save" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default View;